// from https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
export function b64toBlob(b64Data: string, mimeType = '', sliceSize = 512): Blob {
    const byteCharacters = atob(b64Data);
    const byteArrays: Uint8Array[] = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: mimeType });
}

export function dataUrlToBlob(dataUrl: string): string {
    // data:image/gif;base64,R0lGODlh7gK...
    const [head, base64] = dataUrl.split(',');
    const mimeType = head.slice(5, -7);
    const blob = b64toBlob(base64, mimeType);

    return URL.createObjectURL(blob);
}
